import { PAGES } from "../config/constants";
import usePersonStore from "../store/personStore";

export const changeItemIndex = (arr, old_index, new_index) => {
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr; // for testing
};

export const currencyFormatter = (value) => {
  const amount = value ?? 0;
  const formatter = new Intl.NumberFormat('el-GR', {
    style: 'currency',
    currency: 'EUR',
  });
  return formatter.format(amount);
};

export const pageMappr = (key) => {
  const { isLoyaltyEnrolled } = usePersonStore.getState();
  
  const property = {};
  switch (key) {
    case 'Users':
      property['title'] = 'Users';
      property['btnText'] = 'Manage';
      property['navigationUrl'] = '/portal/users';
      property['description'] = '';
      break;
    case 'Loyalty Program':
      property['title'] = 'Avis More';
      property['btnText'] = 'Μάθε περισσότερα';
      property['navigationUrl'] = isLoyaltyEnrolled ? '/portal/loyalty/profile' : '/portal/loyalty/register';
      property['description'] = '';
      break;
    case 'Company Groups':
      property['title'] = 'Manage Company Groups';
      property['btnText'] = 'Manage';
      property['navigationUrl'] = '/group-of-companies-management';
      property['description'] = "Διαχειρίσου και δες τη λίστα των Company Groups.";
      break;

    case 'Documents':
      property['title'] = 'Έγγραφα';
      property['btnText'] = 'Είσοδος';
      property['navigationUrl'] = '/portal/documents';
      property['description'] = "Δείτε ολα τα σχετικά έγγραφα";
      break;

    case 'Roles':
      property['title'] = 'Roles';
      property['btnText'] = 'Manage';
      property['navigationUrl'] = '/portal/roles';
      property['description'] =
        '';
      break;

    case 'Reports':
      property['title'] = 'Αναφορές';
      property['btnText'] = 'Αναζήτηση';
      property['navigationUrl'] = '/reports';
      property['description'] =
        'Αναζήτησε και κατέβασε σε μορφή CSV, Excl ή PDF αναλυτικές αναφορές για να έχεις ολοκληρωμένη πληροφόρηση. ';
      break;

    case 'Invoice':
      property['title'] = 'Τιμολόγια';
      property['btnText'] = 'Αναζήτηση';
      property['navigationUrl'] = '/invoices';
      property['description'] =
        'Αναζήτησε και κατέβασε σε μορφή CSV, Excl ή PDF προηγούμενα τιμολόγια.';
      break;

    case 'Import Drivers':
      property['title'] = 'Μαζική καταχώριση οδηγών';
      property['btnText'] = 'Καταχώριση';
      property['navigationUrl'] = '/portal/import-drivers';
      property['description'] =
        'Η λειτουργία αυτή σου επιτρέπει να καταχωρίσεις πολλούς οδηγούς ταυτόχρονα εύκολα και γρήγορα.';
      break;

    case 'Download Logs':
      property['title'] = 'Download Logs';
      property['btnText'] = 'Manage';
      property['navigationUrl'] = '/portal/downloads';
      property['description'] =
   ''
      break;

    case 'Offers Check':
      property['title'] = 'Offers Check';
      property['btnText'] = 'Manage';
      property['navigationUrl'] = '/portal/offers-check';
      property['description'] =
        '';
      break;

    case 'Offers Reporting':
      property['title'] = 'Offers Reporting';
      property['btnText'] = 'Manage';
      property['navigationUrl'] = '/portal/offers-reporting';
      property['description'] =
        '';
      break;

    case 'Booking Reporting':
      property['title'] = 'Booking Reporting';
      property['btnText'] = 'Manage';
      property['navigationUrl'] = '/portal/booking-reports';
      property['description'] =
        'Από τον παρακάτω πίνακα μπορείτε να κατεβάσετε δεδομένα που αφορούν τη συντήρηση των αυτοκινήτων σας';
      break;

    default:
      property['label'] = '';
      property['title'] = '';
      break;
  }

  return property;
};

export const reportMapper = (key) => {
  const property = {};
  switch (key) {
    case 'fleet':
      property['label'] = 'Στοιχεία στόλου';
      property['title'] =
        'Αναλυτικές αναφορές και δεδομένα για όλα τα αυτοκίνητα του στόλου.';
      break;

    case 'replacements':
      property['label'] = 'Στοιχεία αυτοκινήτων αντικατάστασης';
      property['title'] =
        'Αναλυτικές αναφορές για όλα τα αυτοκίνητα αντικατάστασης.';
      break;
    case 'maintenance':
      property['label'] = 'Στοιχεία συντήρησης';
      property['title'] =
        'Αναλυτικές αναφορές για όλα τα δεδομένα που αφορούν την τακτική και έκτακτη συντήρηση του αυτοκινήτου.';
      break;

    case 'accidents':
      property['label'] = 'Στοιχεία ατυχημάτων';
      property['title'] =
        'Αναλυτικές αναφορές για όλα τα ατυχήματα των αυτοκινήτων.';
      break;

    case 'accidentcost':
      property['label'] = 'Κόστη ατυχημάτων';
      property['title'] =
        'Αναλυτικές αναφορές για το κόστος επισκευής των ατυχημάτων.';
      break;

    case 'billing':
      property['label'] = 'Στοιχεία χρεώσεων';
      property['title'] =
        'Αναλυτικές αναφορές για χρεώσεις που αφορούν τα αυτοκίνητα του στόλου.';
      break;
    default:
      property['label'] = '';
      property['title'] = '';
      break;
  }

  return property;
};

export const getRolesAndAcess = (data) => {
  const roles = {
    admin: [],
    docadmin: [],
    reportadmin: [],
    fleetadmin: [],
    contactCenter: [],
    driver: [],
    RAC:[],
  };

  let hasMyCarAccess = false;
  let hasRacAccess = false;

  let pageAccess = new Set();
  data.data.forEach(({ id, title }) => {
    switch (id) {
      case '1': {
        roles['admin'] = [
          ...roles['admin'],
          'Users', // Import User
          'Roles',
          'Reports',
          'Invoice',
          'Import Drivers',
          'My Car',
          'Download Logs',
        ];
        // Users, Roles
        break;
      }

      case '2': {
        //may not required
        // roles['admin'] = [...roles['admin'], title];
        // DownloadLogs [Admin]
        break;
      }
      case '3': {
        roles['docadmin'] = ['Offers Check']; // Offer Check [Doc Admin]

        break;
      }
      case '4': {
        roles['reportadmin'] = [...roles['reportadmin'], title];

        // Offer Reporting [Report Admin]
        break;
      }
      case '5': {
        roles['reportadmin'] = [...roles['reportadmin'], title]; // Booking Reporting, Booking Statistics [Report Admin]
        break;
      }
      case '6': {
        pageAccess.add(title);
        // Invoice [Admin, Fleet Admin]
        break;
      }
      case '7': {
        pageAccess.add(title);
        // Reports [Admin, Fleet Admin]
        break;
      }
      case '8': {
        roles['fleetadmin'] = [
          ...roles['fleetadmin'],
          'Track Your Car',
          'My Car',
          'Import Drivers',
          'Reports',
          'Invoice',
        ];
        // Track Your Car [Fleet Admin]
        break;
      }
      case '9': {
        hasMyCarAccess = true;
        // My Car [Admin, Contract Center, Fleet Admin, Driver]
        break;
      }
      case '10': {
        // FAQ  [All]
        break;
      }
      case '11': {
        // Mobility [Got removed from System]
        break;
      }
      case '12': {
        // Import Drivers [Admin, Fleet Admin, Contract Center]
        break;
      }
      case '13': {
        // Add "Company Groups" to admin and fleetadmin roles
        roles['admin'] = [...roles['admin'], 'Company Groups'];
        pageAccess.add(title); // Add "Company Groups" to pageAccess
        break;
      }
      case '14': {
        roles['RAC'] = [...roles['RAC'], title]
        hasRacAccess = true;
        pageAccess.add(title); // Add "Loyalty" to pageAccess
        break;
      }
      case '1.1': {
        roles['contactCenter'] = [
          ...roles['contactCenter'],
          'Users',
          'My Car',
          'Import Drivers',
        ];
        // Users // [Contract Center]
        break;
      }

      default: {
        roles['fleetadmin'] = [
          ...roles['fleetadmin'],
          'My Car',
          'Import Drivers',
          'Invoices',
          'Reports',
          'Track your car',
        ];
      }
    }
  });

  let userRoles = [];

  Object.keys(roles).forEach((key) => {
    if (key === 'RAC') return;

    if (roles[key].length) {
      userRoles = [...userRoles, key];
      roles[key].forEach((item) => {
        pageAccess.add(item);
      });
    }
  });
  pageAccess = Array.from(pageAccess);


  if (userRoles.length === 0 && hasRacAccess && !hasMyCarAccess && pageAccess.length === 1 ) {
    userRoles = [...userRoles, 'RAC'];
  }

  if (
    (userRoles.length === 0 ||
      (!userRoles.includes('admin') && !userRoles.includes('fleetadmin'))) &&
    hasMyCarAccess
  ) {
    userRoles = [...userRoles, 'driver'];
    pageAccess = [...pageAccess, 'My Car'];
  }

  return { userRoles, pageAccess };
};

// export const filterOrderedCarList = (orderdCarList = {}, carList = {}) => {
//   const orderList = {
//     ...orderdCarList,
//     data: [],
//   };
//   orderdCarList.data &&
//     orderdCarList.data.forEach((carData) => {
//       if (carData.state.step === 7 || carData.state.step === 8) {
//         const carMake = carData.carTitle && carData.carTitle.split(' ')[0];
//         const leasingData = {
//           ...carData,
//           Automatic: 0,
//           BodyType: '',
//           CO2: 0,
//           Code: '',
//           EndDate: '-',
//           FirstLicenseDate: '-',
//           FuelType: '',
//           Hybrid: 0,
//           MakeName: carMake,
//           ModelId: '',
//           ModelName: carMake,
//           photoURLs: [],
//           pickupdelivery: 0,
//         };
//         if (
//           carList.data &&
//           (carData.vehPlate === null || !carList.data?.find((item) => item.plateno === carData.vehPlate)) &&
//           !carList.data?.find((item) => item.cncode === carData.cncode)
//         ) {
//           carList.data.push(leasingData);
//         }
//       } else {
//         orderList.data.push(carData);
//       }
//     });
//   return orderList;
// };


export const filterOrderedCarList = (orderdCarList = {}, carList = {}) => {
  const orderList = {
    ...orderdCarList,
    data: [],
  };

  orderdCarList.data &&
    orderdCarList.data.forEach((carData) => {

      const shouldSkipMultiQtyOrderWithExistingPlate =
        carData?.quantity > 1 &&
        ((Array.isArray(carData?.vehPlate) &&
        carData?.vehPlate.length > 0 &&
        Array.isArray(carList?.data) &&
        carList.data.some((car) =>{
          return car?.plateno && carData?.vehPlate.includes(car?.plateno)
        })) || carList.data.some((car) =>{
          return car?.plateno && carData?.vehPlate === car?.plateno
        }))

      if (shouldSkipMultiQtyOrderWithExistingPlate) {
        return; // <-- do not include / do not mutate anything for this order item
      }

      // if (shouldSkipMultiQtyOrderWithExistingPlate && Array.isArray(carData?.vehPlate)) {
      //   carData?.vehPlate?.forEach((plate) => {
      //     if (!plate) return;
      //     const matchedCar = carList.data?.find((c) => c?.plateno === plate);
      //     if (matchedCar) {
      //       matchedCar.isFromMultipleOrder = true; // new flag - non existing from BE. We create this for cars coming from multiple orders
      //     }
      //   });

      //   return; // keep existing behavior: do not include this order item
      // }

      const isStep7or8 = carData.state.step === 7 || carData.state.step === 8;

      if (isStep7or8) {
        // Try to find an existing car by plate or cncode
        const existingByPlate =
          carData.vehPlate !== null &&
          carList.data?.find((item) => item.plateno === carData.vehPlate);

        const existingByCn =
          carList.data?.find((item) => item.cncode === carData.cncode);

        const existingCar = existingByPlate || existingByCn;

        if (existingCar) {
          // Augment the existing car with orderLine (without changing other logic)
          existingCar.orderLine = carData?.orderLine;
          existingCar.quantity = carData?.quantity;
          existingCar.make = carData?.make;
          existingCar.model = carData?.model;
          // existingCar.hasAssignedDriver = carData?.hasAssignedDriver;
          // existingCar.plateno = carData?.plateno || carData?.vehPlate;
        } else {
          // Build the synthetic leased-like entry (unchanged) and include orderLine
          const carMake = carData.carTitle && carData.carTitle.split(' ')[0];
          const carModel = carData.carTitle && carData.carTitle.split(' ')[1];
          const leasingData = {
            ...carData,
            Automatic: 0,
            BodyType: '',
            CO2: 0,
            Code: '',
            EndDate: '-',
            FirstLicenseDate: '-',
            FuelType: '',
            Hybrid: 0,
            MakeName: carMake,
            make: carData?.make,
            model: carData?.model,
            ModelId: '',
            ModelName: carModel,
            photoURLs: [],
            pickupdelivery: 0,
            orderLine: carData?.orderLine,
            quantity: carData?.quantity,
            hasAssignedDriver: carData?.hasAssignedDriver,
          };

          if (
            carList.data &&
            (carData.vehPlate === null ||
              !carList.data?.find((item) => item.plateno === carData.vehPlate)) &&
            !carList.data?.find((item) => item.cncode === carData.cncode)
          ) {
            carList.data.push(leasingData); // keep existing mutation behavior
          }
        }
      } else {
        // Keep non-7/8 orders as pending in orderList
        orderList.data.push(carData);
      }
    });

  if (carList.data) {
    carList.data.sort((a, b) => {
      
      const aHasOrder = !!a.orderLine;
      const bHasOrder = !!b.orderLine;

      // 1) orderLine-filled items first
      if (aHasOrder !== bHasOrder) {
        return bHasOrder - aHasOrder; // true first
      }

      // 2) among orderLine items: code 1007 last
      const aIs1007 = a.orderLine?.code === '1007';
      const bIs1007 = b.orderLine?.code === '1007';

      if (aIs1007 !== bIs1007) {
        return aIs1007 - bIs1007; // false first, true last
      }

      // 3) otherwise keep relative order (but note: JS sort isn't guaranteed stable everywhere)
      return 0;

    });
  }


  return orderList;
};


export const manageOrderedCarList = (carList) => {
  const orderedCarsList = [];
  const carInprogressList = [];
  carList &&
    carList.forEach((carData) => {
      if (
        carData.state.step === 7 ||
        carData.state.step === 8 ||
        carData.state.step === 9
      ) {
        orderedCarsList.push(carData);
      } else {
        carInprogressList.push(carData);
      }
    });

  return { orderedCarsList, carInprogressList };
};

export const clearStoreage = () => {
  localStorage.removeItem('user-info');
  localStorage.clear();
  sessionStorage.clear();
};

export const checkDriverManage = (actions) => {
  if (actions) {
    const isFound = actions.find(
      (item) => item.name === 'driverManage' && !!item.enabled
    );
    if (isFound) {
      return true;
    }
    return false;
  }
  return false;
};

export const checkBookingEnabled = (actions) => {
  if (actions) {
    const isFound = actions.find(
      (item) => item.name === 'booking' && !!item.enabled
    );
    if (isFound) {
      return true;
    }
    return false;
  }
  return false;
};

export const mapStepToText = (step) => {
  switch (step) {
    case 1:
      return 'Αποδοχή προσφοράς';
    case 2:
      return 'Φόρμα νέου πελάτη';
    case 3:
      return 'Υποβολή δικαιολογητικών';
    case 4:
      return 'Διαδικασία έγκρισης';
    case 5:
      return 'Υπογραφή συμβολαίων';
    case 6:
      return 'Πληρωμή';
    case 7:
      return 'Ολοκλήρωση παραγγελίας';
    case 8:
      return 'Διεκπεραίωση παραγγελίας';
    case 9:
      return 'Παράδοση αυτοκινήτου';
    default:
      return 'Δημιουργία προσφοράς';
  }
};

export const mapStepToMessage = (step, substep) => {
  switch (step) {
    case 0:
      return 'Προετοιμάζουμε την προσφορά σου, θα είναι διαθέσιμη πολύ σύντομα.';
    case 4:
      return 'Έχουμε παραλάβει τα δικαιολογητικά σου και θα επικοινωνήσουμε μαζί σου σύντομα μέσω email.';
    case 5:
      if (substep === '') {
        return 'Το αίτημά σου έχει εγκριθεί και σε λίγα λεπτά τα συμβόλαιά σου θα είναι έτοιμα προς υπογραφή. Θα λάβεις σχετική ενημέρωση και μέσω email.';
      } else if (substep === 0) {
        return 'Συμπλήρωσε τις παρακάτω επιλογές όσο ολοκληρώνεται η δημιουργία των συμβολαίων.';
      }
      break;
    // case 6:
    //     if (substep === 3 && paymentMethod === 'card') {
    //         return 'Έχει ολοκληρωθεί η πληρωμή με: Πιστωτική/χρεωστική κάρτα. Σύντομα θα ενημερωθείς για την παραγγελία του αυτοκινήτου σου.';
    //     } else if (substep === 3 && paymentMethod === 'rfcode') {
    //         return 'Έχεις επιλέξει πληρωμή με κωδικό ηλεκτρονικής πληρωμής. Με την επιβεβαίωση της πληρωμής από την τράπεζα, θα ενημερωθείς για την παραγγελία του αυτοκινήτου του.';
    //     }
    //     break;
    case 7:
      if (substep === 3) {
        return 'Η παραγγελία σου έχει ολοκληρωθεί. Σύντομα θα λάβεις ενημέρωση για την εκτιμώμενη ημερομηνία παράδοσης.';
      } else if (substep === '') {
        return 'Το αίτημά σου έχει ολοκληρωθεί και το αυτοκίνητο βρίσκεται σε στάδιο παραγγελίας. Σύντομα θα λάβεις ενημέρωση για την εκτιμώμενη ημερομηνία παράδοσης.'
      }
      break;
    default:
      return undefined;
  }
};
